<template>
  <div class="w-100 h-100 d-flex flex-column justify-center align-center">
    <div id="loading-animal" style="width: 100px; height: 100px"></div>
    <h4 style="color: #7e58c4; font-family: maplestory">집에서 나오는중</h4>
  </div>
</template>

<script>
import lottieWeb from "lottie-web";

export default {
  mounted() {
    const el = this.$el.querySelector("#loading-animal");
    this.animation = lottieWeb.loadAnimation({
      container: el,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: `/icons/loading-animal-symbol.json`,
    });
    this.animation.setSpeed(0.7);
  },
};
</script>

<style></style>
